import './Modal.scss'

import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { upperFirst } from 'lodash'
import classNames from 'classnames'

import Portal from './Portal'
import Loading from './Loading'

interface Props {
  children: ReactNode
  top?: number
  left?: number
  buttonId?: string
  confirmTitle?: string
  confirmTheme?: ConfirmTheme
  isLoading?: boolean
  onDisableModal?: () => void
  onConfirm: () => void
}

export enum ConfirmTheme {
  ODC_WHITE = 'odcWhite',
  ODC_RED = 'odcRed',
}

export default function Modal({
  children,
  top,
  left,
  confirmTitle,
  confirmTheme = ConfirmTheme.ODC_WHITE,
  onDisableModal,
  onConfirm,
  isLoading,
  buttonId,
}: Props) {
  const { t } = useTranslation()

  return (
    <Portal position="top">
      <div className="Modal">
        <div className="Modal__wrapper" style={{ top, left }}>
          <div className="Modal__content">{children}</div>
          <div className="Modal__buttons">
            {onDisableModal && (
              <button id="ModalClose" className="Modal__button Modal__cancelButton" onClick={onDisableModal}>
                {t('cancel')}
              </button>
            )}
            <button
              id={buttonId}
              className={classNames('Modal__button Modal__confirmButton', {
                'Modal__confirmButton--whiteTheme': confirmTheme === ConfirmTheme.ODC_WHITE,
                'Modal__confirmButton--redTheme': confirmTheme === ConfirmTheme.ODC_RED,
              })}
              onClick={onConfirm}
            >
              {isLoading ? <Loading visible size={25} /> : upperFirst(confirmTitle) || t('confirm')}
            </button>
          </div>
        </div>
      </div>
    </Portal>
  )
}
